<div class="page_container" [class.flow]="tab === 'replies'">
  <ui-page-header [title]="'settings.smart_inbox' | translate" [lucideIcon]="'Mail'">
    <ui-button
      *ngIf="tab === 'connections'"
      type="primary"
      [label]="('settings.smart_inbox_connect_account' | translate | uppercase)"
      icon="plus-cc"
      iconSize="large"
      iconPosition="start"
      (click)="connectAccount()">
    </ui-button>
  </ui-page-header>

  <!-- Tab bar -->
  <div class="tabbar">
    <button class="tab" [class.active]="tab === 'connections'" (click)="setTab('connections')">
      {{ 'settings.smart_replies_tab_connections' | translate }}
      <span class="tab_count" *ngIf="mailboxes.length">{{ mailboxes.length }}</span>
    </button>
    <button class="tab" [class.active]="tab === 'replies'" (click)="setTab('replies')">
      {{ 'settings.smart_replies_tab' | translate }}
    </button>
  </div>

  <!-- Connections tab -->
  <ng-container *ngIf="tab === 'connections'">
    <div class="header_settings" *ngIf="!loading && !error">
      <span class="description">{{ 'settings.smart_inbox_description' | translate }}</span>
    </div>

    <div class="error_message" *ngIf="error">{{ error }}</div>

    <div class="table_card" *ngIf="!error">
      <div class="table_wrapper">
        <table class="mailboxes_table">
          <thead>
            <tr class="table_header_row">
              <th class="account_column">{{ 'settings.smart_inbox_account' | translate }}</th>
              <th class="type_column">{{ 'settings.smart_inbox_type' | translate }}</th>
              <th class="sharing_column">{{ 'settings.smart_inbox_sharing' | translate }}</th>
              <th class="owner_column">{{ 'settings.smart_inbox_owner' | translate }}</th>
              <th class="can_view_column">{{ 'settings.smart_inbox_can_view' | translate }}</th>
              <th class="can_send_column">{{ 'settings.smart_inbox_can_send' | translate }}</th>
              <th class="status_column">{{ 'settings.smart_inbox_status' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let mailbox of mailboxes">
              <tr class="table_body_row smart-inbox-settings__row--clickable" (click)="openConnectionDetails(mailbox)">
                <td class="account_cell">
                  <div class="account_identifier">
                    <ui-svg-icon [svgIcon]="'inbox'" size="medium"></ui-svg-icon>
                    <span>{{ mailbox.email }}</span>
                  </div>
                </td>
                <td class="type_cell">
                  <div class="type_icon">
                    <ui-svg-icon [svgIcon]="providerLabel(mailbox.provider) | lowercase" size="medium"></ui-svg-icon>
                    <span class="provider_badge">{{ providerLabel(mailbox.provider) }}</span>
                  </div>
              </td>
                <td class="sharing_cell">
                  <span class="sharing_tag" [class.team]="mailbox.mailbox_type === 'team'" [class.personal]="mailbox.mailbox_type === 'personal'">
                    {{ sharingLabel(mailbox) }}
                  </span>
                </td>
                <td class="owner_cell">{{ mailbox.mailbox_owner_name || '--' }}</td>
                <td class="can_view_cell" [innerHTML]="canViewLabel(mailbox)"></td>
                <td class="can_send_cell" [innerHTML]="canSendLabel(mailbox)"></td>
                <td class="status_cell">
                  <span class="status_dot" aria-hidden="true" [class.connected]="mailbox.connection_status === 'connected'" [class.disconnected]="mailbox.connection_status !== 'connected'"></span>
                  {{ statusLabel(mailbox) }}

                  <!-- Sync state: a connected mailbox can still be failing to sync. -->
                  <span *ngIf="isSyncing(mailbox)" class="sync_state sync_state--syncing">
                    <ui-svg-icon svgIcon="refresh-cc" size="xsmall" class="spin-animation"></ui-svg-icon>
                    {{ syncStatusLabel(mailbox) }}
                  </span>
                  <span *ngIf="hasSyncError(mailbox)"
                        class="sync_state sync_state--error"
                        [matTooltip]="syncErrorFullText(mailbox)"
                        matTooltipClass="conversation-tooltip-info">
                    <ui-svg-icon svgIcon="alert-circle-red" size="xsmall"></ui-svg-icon>
                    {{ syncStatusLabel(mailbox) }}
                  </span>

                  <span *ngIf="mailbox.last_sync_at" class="last_sync">{{ lastSyncLabel(mailbox) }}</span>
                  <span *ngIf="hasSyncError(mailbox)" class="sync_error_reason">{{ syncErrorSummary(mailbox) }}</span>
                </td>
              </tr>
            </ng-container>
            <tr *ngIf="loading" class="table_body_row">
              <td colspan="8" class="loading_cell">
                <div class="smart-inbox-settings__loading">
                  <ui-svg-icon svgIcon="refresh-cc" size="medium" class="spin-animation"></ui-svg-icon>
                  <span>{{ 'smart_inbox.inbox_view.loading_in_progress' | translate }}</span>
                </div>
              </td>
            </tr>
            <tr *ngIf="!loading && mailboxes.length === 0" class="table_body_row">
              <td colspan="8" class="empty_cell">{{ 'settings.smart_inbox_no_accounts' | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <app-pagination
      *ngIf="metadata && metadata.pages > 1"
      [pagination]="metadata"
      (toPageEvent)="toPage($event)">
    </app-pagination>

    <!-- Display preference for the recipient-mailbox tag shown in Smart Inbox. -->
    <div class="preference_card" *ngIf="!error">
      <div class="preference_text">
        <span class="preference_title">{{ 'settings.smart_inbox_account_tag_title' | translate }}</span>
        <span class="description">{{ 'settings.smart_inbox_account_tag_description' | translate }}</span>
      </div>

      <mat-radio-group
        class="preference_options"
        [ngModel]="mailboxTagDisplay"
        (ngModelChange)="onMailboxTagDisplayChange($event)">
        <mat-radio-button *ngFor="let option of MAILBOX_TAG_DISPLAY_OPTIONS" [value]="option">
          {{ 'settings.smart_inbox_account_tag_option_' + option | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </ng-container>

  <!-- Smart Replies tab -->
  <app-smart-replies-settings
    *ngIf="tab === 'replies'"
    [hasAccounts]="mailboxes.length > 0">
  </app-smart-replies-settings>
</div>
